import React from 'react';
import { withRouter } from 'react-router-dom'
import SEOContent from '../seo_header'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Translation from 'services/translation.service';
import { getPageSeo } from '../../../util';
import * as constants from '../../../constants';
import { getPageContentBySlug } from 'stores/Layout/layoutActions';
import languages from 'languages.json';

function usePrevious(value) {
    const ref = React.useRef();
    React.useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

const SeoLayoutCom = React.memo((props) => {

    const {
        currentRoute,
        location,
        source,
        pageContent,
        getPageContentBySlug,
        translation
    } = props;

    const prevRoute = usePrevious(currentRoute)

    const defaultSeo = React.useMemo(() => {
        if (translation) {
            return {
                "seo_tags": {
                    "meta": [
                        { "name": "robots", "content": "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1", "property": null },
                        { "name": null, "content": "en_US", "property": "og:locale" },
                        { "name": null, "content": "website", "property": "og:type" },
                        { "name": null, "content": Translation.key('generic_seo_facebook_share_message'), "property": "og:title" },
                        { "name": null, "content": Translation.key('generic_seo_meta_description'), "property": "og:description" },
                        { "name": null, "content": window.location.href, "property": "og:url" },
                        { "name": null, "content": Translation.key('generic_seo_site_name'), "property": "og:site_name" },
                        { "name": "description", "content": Translation.key('generic_seo_meta_description'), "property": null }
                    ],
                    "title": Translation.key('generic_seo_tab_title')
                }
            }
        }
        return null;

    }, [translation]);


    const isHomepage = (slug) => {
        return languages[slug] ? true : false;
    }

    const [seo, updateSeo] = React.useState(null);
    const urlItms = location.pathname.split('/');
    const urlItmsLength = urlItms.length;
    const slug = urlItms[urlItmsLength - 1] ? urlItms[urlItmsLength - 1] : urlItms[urlItmsLength - 2];


    ///////////////////////////////////////

    React.useEffect(() => {

        if (
            source === constants.COME_FROM_FLOW_DASHBOARD ||
            !currentRoute ||
            prevRoute === currentRoute
        ) {
            return;
        }


        if (
            currentRoute &&
            (
                currentRoute.name === constants.PAGE_ROUTE_PACKAGE ||
                currentRoute.name === constants.PAGE_ROUTE_BUNDLE
            )
        ) {
            updateSeo(currentRoute.seo_tags);
            return;
        }

        if (isHomepage(slug)) {
            getPageContentBySlug('homepage');
            updateSeo(null);
            return;
        }

        getPageContentBySlug(slug);
        updateSeo(null);


    }, [slug, currentRoute, prevRoute, source, getPageContentBySlug]);

    ////////////////////////////////////////////

    const seoContent = React.useMemo(() => {
        let seoElement = '';

        if (pageContent && pageContent.seo_tags) {
            seoElement = getPageSeo(pageContent.seo_tags)
            return <SEOContent title={seoElement.title} metas={seoElement.meta} />
        }

        if (seo) {
            seoElement = getPageSeo(seo)
            return <SEOContent title={seoElement.title} metas={seoElement.meta} />
        }

        if (translation) {
            seoElement = getPageSeo(defaultSeo['seo_tags'], 'default');
            return <SEOContent title={seoElement.title} metas={seoElement.meta} />
        }
        return null;

    }, [seo, pageContent, translation, defaultSeo])

    ////////////////////////////////////////////

    return seoContent
});

const mapStateToProps = (state) => {
    return {
        currentRoute: state.layout.currentRoute,
        translation: state.layout.translation,
        pageContent: state.layout.pageContent
    }
};
const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        { getPageContentBySlug },
        dispatch
    );
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(SeoLayoutCom));